<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">The Panterra Chronicles</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-1-dual-reality">Chapter 1: Dual Reality</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-2-jackpot-koalas">Chapter 2: Jackpot Koalas</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-3-meanwhile-back-at-the-ranch">Chapter 3: Meanwhile, Back at
                the Ranch</a></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-4-supertramps-rising" title="Link target outside of Sample">Chapter 4: SuperTramps Rising</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-5-wildcard-hunt" title="Link target outside of Sample">Chapter 5: Wildcard Hunt</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-6-ghost-town-gully" title="Link target outside of Sample">Chapter 6: Ghost Town Gully</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-7-entering-a-new-dimension" title="Link target outside of Sample">Chapter 7: Entering a New
                Dimension</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-8-quantum-leap" title="Link target outside of Sample">Chapter 8: Quantum Leap</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-9-the-menace-of-mortsleam" title="Link target outside of Sample">Chapter 9: The Menace of
                Mortsleam</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-10-game-on" title="Link target outside of Sample">Chapter 10: Game On</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-11-lavender-spade" title="Link target outside of Sample">Chapter 11: Lavender Spade</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-12-post-divisional-title-win" title="Link target outside of Sample">Chapter 12: Post-Divisional
                Title Win</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-13-code-crackers" title="Link target outside of Sample">Chapter 13: Code Crackers</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-14-the-panterra-code" title="Link target outside of Sample">Chapter 14: The Panterra Code</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-15-the-collections-of-the-viscount-and-viscountess" title="Link target outside of Sample">Chapter
                15 The Collections of the Viscount and Viscountess</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-16-way-outback-outpost" title="Link target outside of Sample">Chapter 16: Way Outback Outpost</span>
</li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-17-drone-crossing" title="Link target outside of Sample">Chapter 17: Drone Crossing</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-18-the-final-matchup" title="Link target outside of Sample">Chapter 18: The Final Matchup</span></li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-19-beau-dean-visits-his-godfather" title="Link target outside of Sample">Chapter 19: Beau Dean
                Visits His Godfather</span></li>
<li id="toc-li-24"><span href="#/text/ch024#chapter-20-the-koalas-take-the-field" title="Link target outside of Sample">Chapter 20: The Koalas Take
                the Field</span></li>
<li id="toc-li-25"><span href="#/text/ch025#chapter-21-stuck-again-cactus-ridge" title="Link target outside of Sample">Chapter 21: Stuck Again Cactus
                Ridge</span></li>
<li id="toc-li-26"><span href="#/text/ch026#chapter-22-the-battle-of-rainbow-ridge" title="Link target outside of Sample">Chapter 22: The Battle of
                Rainbow Ridge</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?d35db7a2